module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"timeLeft":"距离拍卖","auction":"拍卖中"},"zh_hk":{"timeLeft":"距離拍賣","auction":"拍賣中"},"en":{"timeLeft":"Left","auction":"Pending"},"ja":{"timeLeft":"オークションまで","auction":"オークションに参加"}}')
  delete Component.options._Ctor
}
